'use strict';

/**
 * Предоставляет инструменты для работы с обновлениями Веб-агента.
 *
 * @namespace WebAccess.agent.updates
 * @since 5.0.0.4100
 */
(function (global) {
  var updates = {

    /**
     * Проверить наличие обновлений для Веб-агента.
     *
     * @method WebAccess.agent.updates.checkUpdates
     * @returns {Deferred<boolean>} True – Веб-агент имеет одно или несколько обновлений, иначе False.
     * @see https://api.jquery.com/category/deferred-object/
     */
    checkUpdates: function() {
      var d = $.Deferred();

      //Получаем токен на запрос уведомлений о новых заданиях
      WA.SRV.callSync('/Security.asmx/GetOpToken0', { Operation: TOKEN_OPERATION.UPDATE_AGENT }).done(function(token) {
        d = global.checkUpdates(token, g_UserContextID);
      });

      return d.promise();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получить информацию о прогрессе загрузки обновления Веб-агента.
     * Рассчитывается в процентах.
     *
     * @method WebAccess.agent.updates.getUpdateProgress
     * @returns {number} Процент загруженного обновления.
     */
    getUpdateProgress: function() {
      return global.getUpdateProgress(g_UserContextID);
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  };

  global.updates = updates;
})(window.WebAccess.agent);
